import { Button, Grid, Image } from "antd-mobile";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { CurrencyChanger, Filter, HomeCard } from "../../../../components";

import { useAuth } from "../../../../context/AuthContext";
import levelEnum from "../../../../enumerations/levelEnum";
import rebateModeEnum from "../../../../enumerations/rebateModeEnum";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { envChangeType, envType, getCurrency, getRandomInt } from "../../../../plugins/utils";
import { filterKeyOverview } from "../../enumeration/filterKeyEnum";
import {
  filterSetupBetAmountOverview,
  filterSetupOverview,
} from "../../enumeration/filterSetupEnum";
import overviewTimeEnum from "../../enumeration/overviewTimeEnum";
import { useGetOverview } from "../../hooks/overview.hooks";
import overviewCardEnum from "./enumeration/overviewCardEnum";
import styles from "./style.module.scss";
import "./style.scss";
const Overview = forwardRef(
  (
    {
      homeCardContainerStyle = "",
      backCardStyle = "",
      frontCardStyle = "",
      customOverviewDropdownStyle = "",
      customSearchButtonStyle = "",
      overviewDataCustomStyle = "",
      customOverviewContentTitleStyle = "",
      customOverviewContentStyle = "",
      hideTitle = false,
      gap = 16,
      renderAdditionalContent = null,
      headerOverview = [],
    },
    ref,
  ) => {
    const timeoutRef = useRef();
    const [showCurrencyChanger, setShowCurrencyChanger] = useState(false);
    const [isFakeReload, setIsFakeReload] = useState(false);
    const [localLoading, setLocalLoading] = useState(false);
    const [enableAPIRequest, setEnableAPIRequest] = useState(false);
    const { t } = useTranslation();
    const { rebateMode } = useAuth();
    const nowCurrency = getCurrency();

    const [filterDefaultValue, setFilterDefaultValue] = useState({
      [filterKeyOverview.TIME]: overviewTimeEnum[0].value,
      [filterKeyOverview.LEVEL]: envChangeType(
        "REACT_APP_REMOVED_LEVEL_FILTER",
        envType.ARRAY,
      ).includes(levelEnum[4].value)
        ? levelEnum[0].value
        : levelEnum[4].value,
    });
    const [filterValue, setFilterValue] = useState({
      [filterKeyOverview.TIME]: overviewTimeEnum[0].value,
      [filterKeyOverview.LEVEL]: envChangeType(
        "REACT_APP_REMOVED_LEVEL_FILTER",
        envType.ARRAY,
      ).includes(levelEnum[4].value)
        ? levelEnum[0].value
        : levelEnum[4].value,
    });

    const {
      data: overview,
      isLoading: isLoadingOverview,
      isError: isErrorOverview,
      refetch: refetchOverview,
      isRefetching,
    } = useGetOverview(
      {
        params: {
          ...filterValue,
        },
      },
      {
        enabled: enableAPIRequest,
        onSuccess: () => {
          setEnableAPIRequest(false);
          setIsFakeReload(true);
        },
        onError: () => {
          setEnableAPIRequest(false);
        },
      },
    );

    const renderResult = (item) => {
      if (!overview) return "-";
      switch (item.type) {
        case "number":
          return overview[item.key];
        case "money":
          return moneyFormat(overview[item.key]);
        default:
          return overview[item.key];
      }
    };

    const rightContentRender = () => (
      <div
        onClick={() => {
          setShowCurrencyChanger(true);
        }}
      >
        {t("navBar.currency")}
        <span style={{ color: "var(--adm-color-primary)" }}>{nowCurrency}</span>
      </div>
    );

    const renderCustomTitle = () => {
      const selectedTime = overviewTimeEnum.find(
        (item) => item.value === filterValue[filterKeyOverview.TIME],
      );
      const currentModeLevelEnum = levelEnum;
      const selectedLevel = currentModeLevelEnum.find(
        (item) => item.value === filterValue[filterKeyOverview.LEVEL],
      );
      return {
        overview: `${t(selectedTime?.label)}, ${t(selectedLevel?.label)}`,
      };
    };

    const handleSearch = () => {
      if (isFakeReload === true) {
        setLocalLoading(true);
        setTimeout(() => {
          setLocalLoading(false);
        }, [750]);
        return;
      }
      if (enableAPIRequest === false) {
        setEnableAPIRequest(true);
      } else {
        refetchOverview();
      }
    };

    const renderHeaderOverview = () => {
      if (headerOverview.length <= 0) return;
      if (!overview) return;
      return (
        <Grid columns={3} gap={10} style={{ marginBottom: "24px" }}>
          {headerOverview.map((_data) => {
            return (
              <Grid.Item key={_data.key}>
                <div className={styles.headerContent} style={{ background: _data.background }}>
                  <div className={styles.title}>
                    {t(`administrationCenter.overview.${_data.key}`)}
                  </div>
                  <div className={styles.content}>{overview[_data.key]}</div>
                  <Image
                    className={styles.img}
                    src={`/images/home/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${_data.key}.png`}
                  />
                </div>
              </Grid.Item>
            );
          })}
        </Grid>
      );
    };

    useEffect(() => {
      if (isFakeReload === true) {
        const timeoutDelay = getRandomInt(5, 10);
        timeoutRef.current = setTimeout(() => {
          setIsFakeReload(false);
        }, [timeoutDelay * 1000]);
        return () => {
          clearTimeout(timeoutRef.current);
        };
      }
    }, [isFakeReload]);

    useEffect(() => {
      setLocalLoading(isRefetching);
    }, [isRefetching]);
    useImperativeHandle(ref, () => {
      return {
        getOverviewData() {
          return overview;
        },
      };
    }, [overview]);
    useEffect(() => {
      console.debug("overview", overview);
    }, [overview]);
    return (
      <HomeCard
        title={t("home.overviewTitle")}
        /*renderExtra={rightContentRender}*/ containerStyle={homeCardContainerStyle}
        backCardStyle={backCardStyle}
        frontCardStyle={frontCardStyle}
        hideTitle={hideTitle}
      >
        <div className={`${styles.bodyContainer}`}>
          <div className={styles.overviewFilterContainer}>
            <Filter
              customDropdownStyleClass={`custom-overview-dropdown ${customOverviewDropdownStyle}`}
              customDropDownContainerStyleClass={"custom-overview-dropdown-container"}
              filterSetup={
                rebateMode === rebateModeEnum.WINLOSE
                  ? filterSetupOverview
                  : filterSetupBetAmountOverview
              }
              filterDefaultValue={filterDefaultValue}
              filterValue={filterValue}
              setFilterValue={setFilterValue}
              customDropdownTitle={renderCustomTitle()}
              onReset={() => {
                //if need some aditional reset logic in the page
                console.debug("RESET FILTER");
              }}
              onSubmitSearch={() => {
                setEnableAPIRequest(true);
              }}
            />
            <Button
              color={"primary"}
              size={"small"}
              onClick={handleSearch}
              loading={localLoading}
              className={`${styles.button} ${customSearchButtonStyle}`}
            >
              {t("normal.search")}
            </Button>
          </div>
          <div className={styles.subTitle}>{`${t("mobile.normal.lastUpdate", {
            time: overview?.last_updated_at || "-",
          })}`}</div>
          {renderHeaderOverview()}
          {renderAdditionalContent}
          <Grid columns={3} gap={gap} className={`${overviewDataCustomStyle}`}>
            {overviewCardEnum.map((item) => {
              if (
                !envChangeType("REACT_APP_REMOVED_OVERVIEW_KEY", envType.ARRAY).includes(item.key)
              )
                return (
                  <Grid.Item key={item.key}>
                    <div className={styles.menu}>
                      <div className={styles.overviewTitle}>
                        <div className={`${styles.title} ${customOverviewContentTitleStyle}`}>
                          {t(`administrationCenter.overview.${item.key}`)}
                        </div>
                      </div>
                      <div className={`${styles.overviewContent} ${customOverviewContentStyle}`}>
                        {renderResult(item)}
                      </div>
                    </div>
                  </Grid.Item>
                );
            })}
          </Grid>
          <CurrencyChanger
            visible={showCurrencyChanger}
            onClose={() => {
              setShowCurrencyChanger(false);
            }}
          />
        </div>
      </HomeCard>
    );
  },
);

export default Overview;
